import { render } from "./RelativeTime.vue?vue&type=template&id=19d2a957"
import script from "./RelativeTime.vue?vue&type=script&lang=js"
export * from "./RelativeTime.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__